<template>
  <div class="area-content">
    <div class="mainArea">
      <div class="imageArea">
        <el-button type="primary">去扫描<i class="el-icon-camera-solid el-icon--right" @click="getCameras"></i></el-button>
      </div>
      <div class="descTip">{{ title ? title : '暂未扫描' }}</div>
      <div id="reader" width="600px"></div>
    </div>
  </div>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";
export default {
  name: 'clinicApply',
  data: function () {
    return {
      title: ''
    };
  },
  async created() {
    document.title = '扫描条码';
   
  },
  mounted() {},
  methods: {
    getCameras() {
      Html5Qrcode.getCameras()
        .then((devices) => {
          /**
           * devices would be an array of objects of type:
           * { id: "id", label: "label" }
           */
          if (devices && devices.length) {
            // 如果有2个摄像头，1为前置的
            if (devices.length > 1) {
              this.cameraId = devices[1].id;
            } else {
              this.cameraId = devices[0].id;
            }
            this.devices = devices;
            this.start();
            // .. use this to start scanning.
          }
        })
        .catch((err) => {
          // handle err
          console.log(err);    // 获取设备信息失败
        });
    },
    start() {
      const html5QrCode = new Html5Qrcode("reader");
      html5QrCode
        .start(
          this.cameraId, // retreived in the previous step.
          {
            fps: 10, // sets the framerate to 10 frame per second
            qrbox: { width: 250, height: 250 }, // sets only 250 X 250 region of viewfinder to
            // scannable, rest shaded.
          },
          (decodedText, decodedResult) => {
            // do something when code is read. For example:
            // if (qrCodeMessage) {
            //   this.getCode(qrCodeMessage);
            //   this.stop();
            // }
            console.log(decodedText); 
            console.log(decodedResult);
          },
          (errorMessage) => {
            // parse error, ideally ignore it. For example:
            // console.log(`QR Code no longer in front of camera.`);
            console.log(errorMessage); 
          }
        )
        .catch((err) => {
          // Start failed, handle it. For example,
          console.log(`Unable to start scanning, error: ${err}`);
        });
    },
    stop() {
      this.html5QrCode
        .stop()
        .then((ignore) => {
          // QR Code scanning is stopped.
          console.log("QR Code scanning stopped.");
        })
        .catch((err) => {
          // Stop failed, handle it.
          console.log("Unable to stop scanning.");
        });
    },
    // 获取网址参数
    getQuery() {
      let href = window.location.href; //获取url
      href = decodeURI(href); //使用 decodeURI() 对一个编码后的 URI 进行解码：
      //或者使用decodeURIComponent(href)
      let query = href.substring(href.indexOf('?') + 1); //获取？后面的参数部分
      let param = query.split('&'); //将参数部分-用&分割，转换成数组
      let obj = {};
      for (var i = 0; i < param.length; i++) {
        let per = param[i].split('='); //将数组中的每一项-用=分割，转换成数组
        obj[per[0]] = per[1]; //以键值对的形式储存
      }
      return obj;
    },
    // 获取网址参数
    // getParamsFromURL() {
    //   let url = window.location.href; //获取url
    //   if ('undefined' == url) {
    //     return {};
    //   }
    //   let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
    //   let paraObj = {};
    //   for (let i = 0; i < paraString.length; i++) {
    //     let j = paraString[i];
    //     paraObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length);
    //   }
    //   return paraObj;
    // },
  }
};
</script>

<style lang="scss" scoped>
.area-content {
  height: 100vh;
  width: 100vw;
  // overflow-y: scroll;
  box-sizing: border-box;
}
.mainArea {
  width: 100vw;
  height: auto;
  padding-top: 100px;
  // border: 1px solid red;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.imageArea {
  width: 100vw;
  height: auto;
  display: flex;
  // flex-wrap: wrap;
  justify-content: center;
}
.descTip {
  width: 100vw;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 20px;
  font-size: 16px;
  color: red;
  text-align: center;
}
</style>
